import {
  useController,
  useFieldArray,
  useFormContext,
  useWatch,
} from 'react-hook-form';

import { AssessmentItemFormFields } from '@/components/evaluation/AssessmentItemForm';
import useAssessmentCriteriaValidate from '@/data/hook/evaluation/useAssessmentCriteriaValidate';

const useAssessmentCriteriaForm = () => {
  const { control } = useFormContext<AssessmentItemFormFields>();

  const watchedCriteria = useWatch({ control, name: 'criteria' }) ?? [];
  const itemMaxGrade = useWatch({ control, name: 'maxGrade' }) ?? 0;

  const { validateCriteria, getMaxAvailable } = useAssessmentCriteriaValidate({
    criteria: watchedCriteria,
    itemMaxGrade,
  });

  const {
    fieldState: { error },
  } = useController({ control, name: 'criteria' });

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'criteria',
    keyName: 'fieldId',
    rules: {
      validate: validateCriteria,
    },
  });

  const handleAdd = () =>
    append({
      name: '',
      description: '',
      maxGrade: undefined,
      activityType: '',
    });

  const handleDelete = (index: number) => remove(index);

  return { fields, error, handleAdd, handleDelete, getMaxAvailable };
};

export default useAssessmentCriteriaForm;
